import instructors from "../services/instructors";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        instructors: [],
        ratings: [],
        comments: [],
        instructorDetails: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        errors: null,
        editing: false,
        searchableFields: [
            {
                value: "name",
                text: "Instructor Name"
            },
            {
                value: "enabled",
                text: "Enabled"
            },
            {
                value: "disabled",
                text: "Disabled"
            }
        ]
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        instructors(state, instructors) {
            state.instructors = instructors;
            state.loading = false;
            state.searching = false;
        },
        ratings(state, ratings) {
            state.ratings = ratings;
            state.loading = false;
        },
        comments(state, comments) {
            state.comments = comments;
            state.loading = false;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        editing(state, value) {
            state.editing = value;
        },
        setDetails(state, details) {
            state.instructorDetails = details;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        }
    },
    actions: {
        async getInstructors({ commit }, param) {
            commit("loading");
            try {
                let response = await instructors.getInstructors(param);

                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                await commit("instructors", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveInstructor({ commit }, param) {
            commit("loading");
            try {
                let response = await instructors.saveInstructor(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, Cannot create new instructor.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateInstructor({ commit }, data) {
            commit("loading");

            try {
                let response = await instructors.updateInstructor(
                    data.uuid,
                    data.param
                );

                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update instructor.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async viewInstructor({ commit }, uuid) {
            commit("loading");

            try {
                let response = await instructors.viewInstructor(uuid);
                commit("setDetails", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async deleteInstructor({ commit }, uuid) {
            commit("loading");

            try {
                let response = await instructors.deleteInstructor(uuid);

                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(errors.errors.message);
                commit("loading", false);
            }
        },
        async getRatings({ commit }, param) {
            commit("loading");
            try {
                // let response = await instructors.getRatings(param);
                // // console.log(response);
                let response = { list: [{
                    uuid: "1",
                    schedule_uuid: "September 1, 2019",
                    customer_uuid: "1",
                    rate: "5",
                    phrase: "Hello there! How was your recent session? Rate us now and hope to see you in another class very soon"
                }, {
                    uuid: "1",
                    schedule_uuid: "September 1, 2019",
                    customer_uuid: "1",
                    rate: "5",
                    phrase: "Hello there! How was your recent session? Rate us now and hope to see you in another class very soon"
                }] };
                await commit("ratings", response.list);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async getComments({ commit }, param) {
            commit("loading");
            try {
                // let response = await instructors.getRatings(param);
                // // console.log(response);
                let response = { list: [{
                    uuid : "1",
                    schedule_uuid : "September 1, 2019",
                    customer_uuid : "1",
                    comment : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                    class_name : "Boxing"
                }, {
                    uuid : "2",
                    schedule_uuid : "September 1, 2019",
                    customer_uuid : "1",
                    comment : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                    class_name : "Boxing"
                }] };
                await commit("comments", response.list);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
    }
};
